import {
  AdditionalBorrowing,
  HomeBuyingStage,
  MortgagePurpose,
  NextSteps
} from "../../../types/common";

export enum FF2Step {
  Start = "start",
  Purchase = "purchase",
  PurchaseToLet = "purchase_to_let",
  Remo = "remo",
  EmailToMortgageComparison = "email_to_mortgage_comparison",
  EmailToMip = "email_to_mip",
  EmailToRateTracker = "email_to_rate_tracker",
  RedirectToSignUpPurchase = "redirect_to_sign_up_purchase",
  RedirectToSignUpRemo = "redirect_to_sign_up_remo",
  RedirectToSignUpMip = "redirect_to_sign_up_mip",
  RedirectToSecuredHomepage = "redirect_to_secured_homepage",
  MortgageTooSmallPurchase = "mortgage_too_small_purchase",
  MortgageTooSmallRemo = "mortgage_too_small_remo",
  Signup = "signup",
  MagicLinkSent = "magic_link_sent",
}

export interface FormData {
  mortgagePurpose?: MortgagePurpose;
  propertyValue?: string;
  borrowAmount?: string;
  combinedIncome?: string;
  homeBuyingStage?: HomeBuyingStage;
  deposit?: string;
  dealExpiry?: string;
  additionalBorrowing?: AdditionalBorrowing;
  balance?: string;
  nextSteps?: NextSteps;
  magicLinkSent?: boolean;
}

export type IMarketingConsents = {
  email: boolean;
};
